import { render, staticRenderFns } from "./Situacoes.vue?vue&type=template&id=66f7be70&lang=pug&"
import script from "./Situacoes.vue?vue&type=script&lang=js&"
export * from "./Situacoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports